module.exports = __webpack_public_path__ + "static/Schutzkonzept-10ca3ddebc09d476144f7e403aeae89a.pdf";